export default "__VITE_ASSET__Ctg0POVG__"